import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'About', to: '/' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'For Teams', to: '/for-teams' },
  { label: 'Trust', to: '/trust' },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Contact', to: 'mailto:hello@cogniprint.io' },
];

export function Footer() {
  return (
    <footer className="border-t border-dark-border bg-dark-bg">
      <div className="max-w-4xl mx-auto px-4 py-16 flex flex-col items-center gap-8">
        {/* Wordmark */}
        <img
          src="/logo-horizontal.png"
          alt="CogniPrint"
          className="h-10 w-auto"
        />

        {/* Nav links */}
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {navLinks.map((link) =>
            link.to.startsWith('mailto:') ? (
              <a
                key={link.label}
                href={link.to}
                className="text-sm text-content-secondary hover:text-indigo-500 transition-colors"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className="text-sm text-content-secondary hover:text-indigo-500 transition-colors"
              >
                {link.label}
              </Link>
            ),
          )}
        </nav>

        {/* Social */}
        <div className="flex items-center gap-6 text-sm text-content-muted">
          <a href="https://x.com/CogniPrint" target="_blank" rel="noopener noreferrer" className="hover:text-content transition-colors">
            X: @CogniPrint
          </a>
          <a href="https://linkedin.com/company/cogniprint" target="_blank" rel="noopener noreferrer" className="hover:text-content transition-colors">
            LinkedIn: CogniPrint
          </a>
          <a href="https://instagram.com/CogniPrint" target="_blank" rel="noopener noreferrer" className="hover:text-content transition-colors">
            Instagram: @CogniPrint
          </a>
        </div>

        {/* Origin */}
        <p className="text-sm text-content-muted">
          Built in South Africa. Made for the world.
        </p>

        {/* Legal */}
        <p className="text-xs text-content-dim">
          &copy; 2026 CogniPrint (Pty) Ltd. A Kilonova Ventures subsidiary.
        </p>
      </div>
    </footer>
  );
}
